import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {OfferingForm} from "../forms";
import {offeringService} from "../../services";
import {datetime, forms, objects} from "@atttomyx/shared-utils";

const toData = (offering) => {
    const amount = objects.defaultIfNullOrUndefined(offering.amount, {
        dollars: 0,
        cents: 0,
    });

    return {
        nodeId: offering.nodeId,
        category: offering.category,
        type: offering.type,
        dollars: amount.dollars,
        cents: amount.cents,
        date: objects.defaultIfNullOrUndefined(offering.date, datetime.today()),
        valid: false,
    }
};

const OfferingDialog = (props) => {
    const {snackbar, unique, nodes, offering, showNode, onCancel, onSave} = props;
    const [data, setData] = useState(toData(offering));
    const [saving, setSaving] = useState(false);

    const submitForm = () => {
        const success = (saved) => {
            snackbar.setSuccess("Offering saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
            onCancel();
        };

        const modified = {
            nodeId: data.nodeId,
            category: data.category,
            type: data.type,
            dollars: data.dollars,
            cents: data.cents,
            date: data.date,
        };

        setSaving(true);

        if (offering.id) {
            offeringService.updateOffering(offering.id, modified, success, failure);

        } else {
            offeringService.createOffering(modified, success, failure);
        }
    };

    return <Dialog
        open={true}
        aria-labelledby="offering-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            {offering.id ? "Edit" : "Add"} Offering
        </ClosableDialogTitle>
        <DialogContent className="offering-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <OfferingForm
                    unique={unique}
                    nodes={nodes}
                    data={data}
                    onChange={setData}
                    showNode={showNode}
                />}
        </DialogContent>
        <DialogActions>
            {!saving ?
                <Button
                    color="primary"
                    disabled={!data.valid || !forms.differ(toData(offering), data)}
                    onClick={submitForm}
                >
                    Save
                </Button> : null}
        </DialogActions>
    </Dialog>
}

export default OfferingDialog;
